import React from 'react';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import Switch from '@material-ui/core/Switch';
import Divider from '@material-ui/core/Divider';
import Select from '@material-ui/core/Select';
import Paper from '@material-ui/core/Paper';
import LinearProgress from '@material-ui/core/LinearProgress';
import InputAdornment from '@material-ui/core/InputAdornment';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import TextField from '@material-ui/core/TextField';
import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';
import { mascaraCelular9Digito, formataDataDDMMYYYYParaHTML5, formataDataHTML5ParaDDMMYYYY } from '../../modules/util';
import CONSTANTS from '../../constants';
import FormDadosSolicitante from './form-dados-solicitante';

import FormFiadorContainer from '../../containers/fiadores/form-fiador';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import FormPessoaContainer from '../../containers/fiadores/form-pessoa';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

export default class Fiadores extends React.Component {

    constructor(props) {
        super(props);


    }

    componentDidMount() {
        this.props.getDadosFormFiadores();
    }


    setAba(event, value) {
        this.props.setIndexAbaFiador(value);
    }

    render() {
        console.log("***************");
        if (this.props.envioDeFiadoresConcluidoComSucesso) {

            return (
                <div style={{
                    minHeight: '400px',
                    display: 'flex',
                    justifyContent: 'center',
                    flex: '1',
                    flexDirection: 'column',
                    alignItems: 'center',
                    fontSize: '22px',
                    padding: '33px',
                    textAlign: 'center'
                }}>
                    <div>
                        {this.props.envioDeFiadoresConcluidoComSucesso}
                    </div>
                </div>
            );
        }
        return (
            <div >
                <Tabs
                    className="root-financiamento-interno-scroll"
                    value={this.props.indexAbaFiador}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={this.setAba.bind(this)}
                    centered
                >
                    <Tab label="Solicitante" />
                    <Tab label="Fiadores" />
                </Tabs>
                <Divider />
                <br />  <br />
                {this.props.carregandoForm ? (<LinearProgress color="primary" />) : null}
                <div style={{padding: '10px'}}>{this.props.carregandoForm ? "Aguarde...." : null}</div>
                {this.props.indexAbaFiador == 0 ? (
                    <React.Fragment>
                        <FormDadosSolicitante {...this.props.dadosSolicitacao} />
                        {!this.props.dadosSolicitacao.maiorDeIdade ? (
                            <FormPessoaContainer
                                formTitulo={'Dados do RESPONSÁVEL FINANCEIRO'}
                                tipoPessoa={CONSTANTS._TIPO_PESSOA.RESPONSAVEL}
                                {...this.props.dadosResponsavel}
                            />
                        ) : null}

                        <div style={{ textAlign: 'right', marginTop: '80px' }}>
                            <Button
                                disabled={this.props.carregandoForm}
                                onClick={this.props.setIndexAbaFiador.bind(this, 1)} variant="raised" color="primary" >
                                Ir para Envio de Fiadores
                        </Button>
                        </div>
                    </React.Fragment>
                ) : null}
                {this.props.indexAbaFiador == 1 ? (
                    <FormFiadorContainer {...this.props} />
                ) : null}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/fiadores/fiadores.js